import * as yup from 'yup';

export const nullInterestedPartyInfo = {
  legalFirstName: null,
  legalLastName: null,
  streetAddress: null,
  city: null,
  state: null,
  postalCode: null,
};

export const legalFirstName = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('First Name is required'),
  });

export const legalLastName = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Last Name is required'),
  });

export const streetAddress = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Primary Address is required'),
  });

export const city = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('City is required'),
  });

export const state = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('State is required'),
  });

export const postalCode = yup
  .string()
  .nullable()
  .when('hasInterestedParty', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Zip is required'),
  });

export const interestedPartyValidation = yup
  .object()
  .nullable()
  .shape({
    legalFirstName,
    legalLastName,
    streetAddress,
    city,
    state,
    postalCode,
  });
